module.exports = __webpack_public_path__ + "static/smartmockups-d4a5a9dc2d9282497b3c4380944d104f.jpeg";